module.exports = __webpack_public_path__ + "static/media/rebekah.e83b5ac2.JPG";